
import 'swiper/css/swiper.css'
import { Component, Vue, Prop } from 'vue-property-decorator'
import RealNameAuth from '@/components/RealNameAuth.vue';
import CommonUtils from '@/common-utils';

@Component({components:{RealNameAuth}})
export default class RealNameForm extends Vue{

  @Prop() nextRouteName;

  get nextUrl(): string {
    // 모바일은 현재창
    if(this.$isMobile == true) {
      return CommonUtils.createStaticUrl(this, this.nextRouteName);
    }

    if(!this.$route.query) {
      this.$router.go(-1);
      return '';
    }

    return CommonUtils.createStaticUrl(this, this.$route.query.nextRouteName as string);
  }
}
